import styled from "styled-components";

// BV renders MMI/SPP media through a plugin iframe sized to its content plus a
// 20px "bottomSafetyMargin" (bronte-component-mmi-player resizePluginContainer),
// with no outer margin around the plugin. The former inline `margin: 1.5rem 0`
// on this wrapper put the Express label 16px and the player 24px lower than BV
// (BVEW-2342): the label row then cleared the left rule of a preceding
// "Solved Problem" heading that it still overlaps in BV, so the comparator saw
// an 80px x-offset on every such screen. The padding mirrors the iframe tail.
//
// Chapter menu: BV's Aquila MMI player lists chapters in two equal columns
// (`ul.chapter-list { columns: 2 }`) with a 4px gap between the items
// (`li.chapter-list-item { margin: 0 0 4px 12px }`). The cloudflicks SPP player
// splits chapters into exactly two `.chapter-column` divs as well (column-major,
// ceil(n/2) per column) inside a flex-wrap `.chapter-row`, but above a 1224px
// viewport each column has `min-width: 390px`: two no longer fit the 756px
// popup (95% of the 800px player), the second column wraps under the first and
// every button stretches to the full popup width. Below 1224px the player's
// own media query drops the min-width to 240px, which is why the 1200px
// comparator captures never showed the single column. The rules below let the
// two columns share the popup at every desktop width: a `minmax(0, 1fr)` track
// makes the `.chapter-row` fill the popup (the player's auto track plus
// `justify-content: center` shrink-wraps it to the columns' intrinsic width),
// and `flex: 1 1 0` + `min-width: 0` split it evenly. The player's small-screen
// layout (<= 576px: 200px popup and buttons) is left alone. The item gap mirrors
// BV's 4px; the player's own rule is `margin: 0`, so its buttons touch. The
// player renders inline (no iframe), and the ID prefix plus the doubled class
// outrank its `#cloudflicks-video-js.video-js ...` selectors.
export const SppFigure = styled.div`
  width: 100%;
  max-width: 100%;
  padding-bottom: 20px;

  @media (min-width: 577px) {
    #viewer-express-container
      &&
      .cloudflicks-chapter-popup-panel
      .cloudflicks-chapter-popup-custom-row {
      grid-template-columns: minmax(0, 1fr);
    }
    #viewer-express-container && .cloudflicks-chapter-popup-panel .chapter-column {
      flex: 1 1 0;
      min-width: 0;
    }
  }
  #viewer-express-container && .cloudflicks-chapter-popup-panel .chapter-column li {
    margin-bottom: 4px;
  }
`;

// BV's plugin wraps the label in a bare <h4 class="component-label-section">:
// the theme's `body h4 { margin: 8px 0 -8px }` applies and nothing else, so
// the shared LabelSection's `padding-bottom: 10px` (still right for eText MCQ)
// is a 10px gap between label and player that BV does not have.
//
// Inside the label, the MMI plugin CSS forces the paragraphs inline-block
// (`.component-label > p { display: inline-block !important; margin: 0 }`) and
// only the theme's later `.component-label p { margin-bottom: 0.175em }`
// survives. In Express the theme is rescoped under #viewer-express-container,
// so its `body #viewer-express-container p { margin-top: 8px }` and
// `.component-label p { display: block }` outrank a class-level rule; the ID
// re-asserts the BV-winning values and leaves margin-bottom to the theme.
export const SppLabelSection = styled.h4`
  #viewer-express-container && > .component-label > p,
  #viewer-express-container && > .component-title > p {
    display: inline-block;
    margin-top: 0;
  }
`;
